import React, { useMemo } from "react";
import { Link, useLocation, useMatch } from "react-router-dom";
import HeaderLogoImg from "../assets/header_logo.svg";
import AngleLeft from "../assets/angle_left.svg";
import AnserwerAddIcon from "../assets/anserwer_add_icon.svg";
import HamburgerMenuButtonImg from "../assets/hamburger_menu.svg";
import { Path } from "../routes/PagePath";
import { useHamburgerMenuInfo } from "../features/hamburgerMenu/useHamburgerMenuInfo";
import useLocationHistory from "../features/locationHistory/hooks/useLocationHistory";
import { useAllWellnessChecks } from "../features/wellnessCheck/useAllWellnessChecks";
import { useActivityRepliesUnreadStatus } from "../features/activityReply/hooks/useActivityRepliesUnreadStatus";

const titles = [
    { text: "ログイン", path: Path.signin },
    { text: "ユーザー登録", path: Path.signup },
    { text: "親の様子アンケート", path: Path.wellnessChecksAnswerers },
    { text: "お気に入り", path: Path.favoriteMemories },
    { text: "追加した質問", path: Path.addQuestionAnswerers },
];

export const Header: React.FC = () => {
    const signinMatch = useMatch(Path.signin);
    const signupMatch = useMatch(Path.signup);
    const signupResultMatch = useMatch(Path.signupResult);
    const rootMatch = useMatch(Path.root);
    const answerersMatch = useMatch(Path.answerers);
    const passwordResetSendConfirmationCodeMatch = useMatch(
        Path.passwordResetSendConfirmationCode
    );
    const passwordResetSendConfirmationCodeCompletedMatch = useMatch(
        Path.passwordResetSendConfirmationCodeCompleted
    );
    const passwordResetNewPasswordMatch = useMatch(
        Path.passwordResetNewPassword
    );
    const passwordResetNewPasswordCompletedMatch = useMatch(
        Path.passwordResetNewPasswordCompleted
    );
    const termsMatch = useMatch(Path.terms);
    const createQuestionAnswerersMatch = useMatch(Path.addQuestionAnswerers);
    const questionListMatch = useMatch(`${Path.questionList}/:answererId`);

    const { goBack } = useLocationHistory();
    const { pathname } = useLocation();

    const title = useMemo(() => {
        const title = titles.find((x) => x.path === pathname);
        if (title) return title.text;
        if (questionListMatch) return "追加質問一覧";
        return undefined;
    }, [questionListMatch, pathname]);

    const {
        hamburgerMenuInfo,
        hamburgerMenuSlideOpen,
        hamburgerMenuSlideClose,
        hamburgerMenuClose,
    } = useHamburgerMenuInfo();

    const { hasNewWellnessCheck } = useAllWellnessChecks();
    const { hasNewActivityReply } = useActivityRepliesUnreadStatus();

    const handleClickAngleLeftButton = () => {
        hamburgerMenuClose();
        goBack();
    };

    // 戻るボタンを表示しないページ
    const backPageIconNotDisplayPageMatch = [
        signinMatch,
        signupMatch,
        signupResultMatch,
        rootMatch,
        passwordResetSendConfirmationCodeCompletedMatch,
        passwordResetNewPasswordMatch,
        passwordResetNewPasswordCompletedMatch,
        termsMatch,
    ];

    // ハンバーガーメニューボタンを表示しないページ
    const hamburgerMenuNotDisplayPageMatch = [
        signinMatch,
        signupMatch,
        signupResultMatch,
        passwordResetSendConfirmationCodeMatch,
        passwordResetSendConfirmationCodeCompletedMatch,
        passwordResetNewPasswordMatch,
        passwordResetNewPasswordCompletedMatch,
        answerersMatch,
        termsMatch,
        createQuestionAnswerersMatch,
        questionListMatch,
    ];

    return (
        <header className="fixed left-0 top-0 z-40 box-border flex h-16 w-full items-center justify-center border-b-2 border-gray-200 bg-white">
            {!backPageIconNotDisplayPageMatch.find(
                (matchPage) => matchPage
            ) && (
                <button
                    onClick={handleClickAngleLeftButton}
                    className="absolute left-0 top-4 ml-2"
                >
                    <img src={AngleLeft} alt="AngleLeftImg" />
                </button>
            )}

            {title ? (
                <h2>{title}</h2>
            ) : (
                <Link onClick={hamburgerMenuClose} to={Path.root}>
                    <img src={HeaderLogoImg} alt="HeaderLogoImg" />
                </Link>
            )}

            {!hamburgerMenuNotDisplayPageMatch.find(
                (matchPage) => matchPage
            ) && (
                <div className="absolute right-0 top-4 mr-3">
                    {(hasNewWellnessCheck || hasNewActivityReply) && (
                        <div className="absolute right-5 h-4 w-4 rounded-full bg-red-500"></div>
                    )}
                    <button
                        onClick={() =>
                            hamburgerMenuInfo.hamburgerMenuIsOpen
                                ? hamburgerMenuSlideClose()
                                : hamburgerMenuSlideOpen()
                        }
                    >
                        <img
                            src={HamburgerMenuButtonImg}
                            alt="HamburgerButtonImg"
                        />
                    </button>
                </div>
            )}

            {answerersMatch && (
                <div className="absolute right-0 top-4 mr-3">
                    <Link to={Path.receivernickname}>
                        <img src={AnserwerAddIcon} alt="AnserwerAddIconImg" />
                    </Link>
                </div>
            )}
        </header>
    );
};
